import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const ArrowRightIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5313 12.5304C19.8242 12.2375 19.8242 11.7626 19.5313 11.4697L14.5303 6.46869C14.2374 6.1758 13.7625 6.1758 13.4696 6.46869C13.1768 6.76159 13.1768 7.23646 13.4696 7.52935L17.1903 11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H17.1903L13.4696 16.4707C13.1768 16.7636 13.1768 17.2385 13.4696 17.5314C13.7625 17.8242 14.2374 17.8242 14.5303 17.5314L19.5313 12.5304Z"
      fill="#2A2A2A"
    />
  </IconBase>
);

export default ArrowRightIcon;
